import { Component } from 'react'
import { AppProvider } from './providers/AppState'
import Content from './Content'
import { BeeConfiguration } from './containers'
import './App.css'

class App extends Component {
  render() {
    return (
      <AppProvider>
        <BeeConfiguration {...this.props}>
          <Content {...this.props} />
        </BeeConfiguration>
      </AppProvider>
    )
  }
}

export default App
